import API from 'services/TAPS_API';
import { NDFL3_NOTIFICATION_ID } from '../../constants';

export default function getDetails(query = {}) {
  return API.request({
    method: 'GET',
    url: `/notification/${NDFL3_NOTIFICATION_ID}/results/${query.cardId}/${query.type}`,
  });
}
